import React from "react";
import { Menu, Button, Dropdown, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import build from "redux-object";

import { logOut } from "../../actions/auth.actions";
import { switchTenant, appLoaded } from "../../actions/common.actions";
import TenantModal from "../Tenants/TenantModal";
import WtiService from "../../services/wti.service";
import { get } from "lodash";

const tenantEdit = "Edit tenant";
const tenantAdd = "Add new tenant";

const HomeHeader = ({ appName, inProgress, currentUser, currentTenant, tenants, logOut, setTenant }) => (
  <Menu borderless compact color="orange" attached="top">
    <Menu.Menu>
      <Menu.Item as="h3" style={{ color: "#858585", fontWeight: "bold" }}>
        {appName}
      </Menu.Item>
    </Menu.Menu>

    {!inProgress && (
      <Menu.Menu position="right">
        {currentTenant && (
          <Menu.Item fitted>
            {currentUser && currentUser.admin === true && (
              <div>
                <TenantModal type={tenantEdit} tenantEdit={tenantEdit} currentTenant={currentTenant} icon="setting" />
              </div>
            )}
            <Dropdown
              icon={<Icon className="icon__padded" color="orange" name="chevron down" />}
              className="tenant-list"
              data-test="tenant-list"
              text={currentTenant.name}
              value={currentTenant.slug}
              item
            >
              <Dropdown.Menu>
                <Dropdown.Header content="Switch tenant" />
                <Dropdown.Divider />
                {tenants.map(tenant => (
                  <Dropdown.Item
                    key={tenant.slug}
                    value={tenant.slug}
                    text={tenant.name}
                    onClick={(e, data) => {
                      if (currentUser.admin && data.value !== currentTenant.slug) {
                        setTenant(tenants.find(tenant => tenant.slug === data.value));
                      }
                    }}
                  />
                ))}
                {currentUser && currentUser.admin === true && (
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Header>
                      <TenantModal type={tenantAdd} tenantAdd={tenantAdd} icon="plus" />
                    </Dropdown.Header>
                  </>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        )}
        <Menu.Item fitted>
          {currentUser ? (
            <Dropdown
              icon={<Icon className="icon__padded" color="orange" name="chevron down" />}
              item
              text={currentUser.email}
              data-test="profile_dropdown"
            >
              <Dropdown.Menu data-test="profile_menu">
                {currentUser.admin && (
                  <>
                    <Dropdown.Item
                      onClick={() => {
                        if (window.confirm("This will push translation keys to the WTI server. Are you sure?")) {
                          WtiService.updateKeys();
                        }
                      }}
                    >
                      Push keys to WTI
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        if (window.confirm("This will get latest translated labels from the WTI server. Are you sure?")) {
                          WtiService.fetchTranslations();
                        }
                      }}
                    >
                      Pull translations from WTI
                    </Dropdown.Item>
                  </>
                )}
                <Dropdown.Item data-test="logout" as={Link} to={`/users/change-password`}>
                  Change Password
                </Dropdown.Item>
                <Dropdown.Item data-test="logout" onClick={logOut}>
                  Sign out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <Link to="/login">
              <Button color="orange" basic>
                Log in
              </Button>
            </Link>
          )}
        </Menu.Item>
      </Menu.Menu>
    )}
  </Menu>
);

const mapStateToProps = state => ({
  ...state.common,
  currentUser: get(state, "common.currentUser"),
  tenants: build(state.common, "tenants", null, { ignoreLinks: true })
});
const mapDispatchToProps = dispatch => ({
  loadApp: () => dispatch(appLoaded()),
  logOut: () => dispatch(logOut()),
  setTenant: tenant => dispatch(switchTenant(tenant))
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeHeader);
